import React from 'react';
import { getAvatarStyle } from '../../lib/s3';
import { makeStyles } from '@material-ui/core/styles';
 

const formatCurrency = (value) => {
  if (!value) return 'N/A';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

const useStyles = makeStyles((theme) => ({
  property: {
    backgroundColor: '#fff',
    margin: theme.spacing(2),
    boxShadow: '0 1px 3px rgba(0,0,0,.1)',
  },
  propertyImage: {
    position: 'relative',
    height: '200px',
    overflow: 'hidden',
  },
  ribbon: {
    position: 'absolute',
    top: '20px',
    right: '-21px',
    padding: '3px 20px',
    backgroundColor: (props) => props.ribbonColor || '#333333',
    color: '#fff',
    textTransform: 'uppercase',
    transform: 'rotate(45deg)',
  },
  tagStatus: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    padding: '3px 8px',
    backgroundColor: '#1396e2',
    color: '#fff',
  },
  aside: {
    padding: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  userButton: {
    border: 'none',
    outline: 'none',
    color: '#1396e2',
    padding: 0,
    background: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#5a5a5a',
  },
  dataList: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: theme.spacing(1),
    margin: theme.spacing(2, 0),
  },
  readMore: {
    border: 'none',
    outline: 'none',
    padding: 0,
    fontSize: '14px',
    color: '#1396e2',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const ListCard = ({ user, currentCompany }) => {
  const classes = useStyles({ 
    ribbonColor: user.obfuscated ? '#88B001' : '#333333' 
  });
  const avatarCompanySettings = {
    avatar_directory: currentCompany?.avatar_directory,
    avatar_background_color: currentCompany?.avatar_background_color,
    primary_color: currentCompany?.primary_color,
  };
  const avatarStyle = getAvatarStyle(user.profile_picture, avatarCompanySettings);

  const renderRibbon = () => {
    if (user.obfuscated) return 'Managed';
    if (user.is_student) return currentCompany.student_word;
    if (user.has_team) return 'Team';
    if (user.created_at > 30) return 'New';
    return null;
  };

  const ribbonText = renderRibbon();

  return (
    <div className={classes.property}>
      <div>
        <div className={classes.propertyImage}>
          <div className={classes.tagStatus}>{user.tag_info}</div>
          {ribbonText && <div className={classes.ribbon}>{ribbonText}</div>}
          <div className="overlay">
            <div className="info">
              {/* SocialButtons component would go here */}
            </div>
          </div>
          <button 
            className={classes.userButton}
            onClick={() => { document.x.a = user.fb_user_name; }}
          >
            <img 
              src={avatarStyle.url} 
              alt={user.allowed_name}
              style={{
                width: '100%',
                height: avatarStyle.isNewStyle ? '100%' : '100%',
                objectFit: avatarStyle.isNewStyle ? 'contain' : 'cover',
                objectPosition: avatarStyle.isNewStyle ? 'bottom center' : undefined,
                transform: avatarStyle.isNewStyle ? 'scale(0.85)' : undefined,
                transformOrigin: avatarStyle.isNewStyle ? 'bottom center' : undefined,
                backgroundColor: avatarStyle.backgroundColor,
              }}
            />
          </button>
        </div>

        <aside className={classes.aside}>
          <header className={classes.header}>
            <h3>
              <button
                className={classes.userButton}
                onClick={() => { document.x.a = user.fb_user_name; }}
              >
                #{user.allowed_name}
              </button>
            </h3>
            <div className={classes.location}>
              <span className="fa fa-map-marker" />
              {user.show_city ? (
                `${user.city}, ${user.province}`
              ) : user.county ? (
                `${user.county} County, ${user.province}`
              ) : (
                user.province
              )}
            </div>
          </header>

          <p>
            {user.headline 
              ? user.headline.substring(0, 29).replace(/\s\w+\s*$/, '...')
              : `Opportunity in ${user.county || user.province}`
            }
          </p>

          <dl className={classes.dataList}>
            {currentCompany.business_type === 'wealth_rj' ? (
              <>
              <dt>Gross Production:</dt>
              <dd>{formatCurrency(user.gross_production)}</dd>
              <dt>Assets Under Management:</dt>
              <dd>{formatCurrency(user.assets_under_management)}</dd>
              <dt>Number of Clients:</dt>
              <dd>{user.number_of_clients}</dd>
              <dt>Years Practicing</dt>
              <dd>{user.years_practicing}</dd>
            </>)
            :
            <>
              <dt>Annual Revenue:</dt>
              <dd>{formatCurrency(user.annual_revenue)}</dd>
              <dt>Recurring Revenue:</dt>
              <dd>{formatCurrency(user.recurring_revenue)}</dd>
              <dt>Number of Clients:</dt>
              <dd>{user.number_of_clients}</dd>
              <dt>P & C</dt>
              <dd>
                <dd>
                  {Array.from({ length: user?.product_mix?.p_c_stars || 0 }).map((_, index) => (
                  <i key={index} className="fas fa-star" style={{ color: '#FFD700' }} />
                  ))}
                </dd>
              </dd>
            </>}
          </dl>

          <hr style={{ marginTop: 10, marginBottom: 10 }} />
          
          <button 
            className={classes.readMore}
            onClick={() => { document.x.a = user.fb_user_name; }}
          >
            Read More
            <i className="fas fa-chevron-right" style={{ color: '#1396e2' }} />
          </button>
        </aside>
      </div>
    </div>
  );
};

export default ListCard;